import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import StockUniformesLayer from "../components/StockUniformesLayer";
import { useTranslation } from "../i18n/I18nContext";

const StockUniformesPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("stock.breadcrumb")} />
      <StockUniformesLayer />
    </MasterLayout>
  );
};

export default StockUniformesPage;
